<template>
  <div class="video-preview" :class="{ 'share-video-preview': isShare }">
    <video
      :src="url"
      controls
      controlslist="nodownload noremoteplayback"
      :disablePictureInPicture="true"
      :class="[showPreVideoClass]"
      id="preVideo"
    />
  </div>
</template>

<script>
import clientDiff from '@client-diff';

const IS_ELECTRON = clientDiff.IS_ELECTRON;
export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    isShare: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showPreVideoClass() {
      if (this.isShare) {
        return 'share-video-height';
      } else {
        return this.IS_ELECTRON ? 'client-video-height' : 'web-video-height';
      }
    }
  },
  data() {
    return {
      IS_ELECTRON
    };
  }
};
</script>

<style lang="scss" scoped>
.video-preview {
  display: flex;
  justify-content: center;
  align-items: center;
  .client-video-height {
    height: calc(100vh - 84px);
  }

  .web-video-height {
    height: calc(100vh - 54px);
  }

  .share-video-height {
    height: 100%;
  }

  .video-width {
    width: 100%;
  }
}

#preVideo {
  max-width: 100%;
  max-height: 100%;
}

.share-video-preview {
  height: 100%;
}
</style>
